export default __webpack_public_path__ + "static/media/shareDrive.b70e99e8.svg";